import { ChangeDetectionStrategy, Component, ElementRef, Input, Renderer2 } from '@angular/core';
import { TrueNorthLandscapeCardStackBackgroundViewModel } from './true-north-landscape-card-stack-background-view-model';
import { CardBackgroundComponent } from '../../card-background.component';
import type { CardData } from '../../../../../../../models/print-cards/card-data';

@Component({
  selector: 'app-true-north-landscape-card-stack-background',
  templateUrl: './true-north-landscape-card-stack-background.component.html',
  styleUrls: ['./true-north-landscape-card-stack-background.component.scss'],
  providers: [TrueNorthLandscapeCardStackBackgroundViewModel],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class TrueNorthLandscapeCardStackBackgroundComponent extends CardBackgroundComponent {
  constructor(
    public viewModel: TrueNorthLandscapeCardStackBackgroundViewModel,
    elementRef: ElementRef,
    renderer2: Renderer2
  ) {
    super(viewModel, elementRef, renderer2);
  }

  @Input() override cardBackground: CardData;
}
